import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import cn from 'classnames';

import SupplementResponseStatusDot from '@components/SupplementResponseStatusDot/SupplementResponseStatusDot';
import { IMedicationResponse } from '@interfaces/medications';
import { TSupplementResponseStatus } from '@interfaces/supplements';

import './style.scss';

export interface IProps {
  data: IMedicationResponse;
  isSelected: boolean;
  className?: string;
  onRemove: (medicationInquiryId: number) => void;
  onShowDetails: (data: IMedicationResponse) => void;
}

const MedicationResponseCard: FC<IProps> = ({
  className,
  data,
  isSelected,
  onRemove,
  onShowDetails,
}) => {
  const { t } = useTranslation();

  const handleShowDetails = useCallback(() => {
    onShowDetails(data);
  }, [onShowDetails, data]);

  const handleRemove = useCallback(() => {
    onRemove(data.medicationInquiryId);
  }, [onRemove, data.medicationInquiryId]);

  if (!data) {
    return null;
  }

  return (
    <div
      className={cn(
        'medication-response-card',
        { 'medication-response-card_active': isSelected },
        className,
      )}
    >
      {/* Separate clickable card surface to avoid event collisions with clickable risk level button below */}
      <div className="medication-response-card__surface" onClick={handleShowDetails} />
      <div className="medication-response-card__name">{data.name}</div>
      {data.supplementInquiryStatusId !== TSupplementResponseStatus.Complete && (
        <SupplementResponseStatusDot
          className="medication-response-card__status"
          value={data.supplementInquiryStatusId}
        />
      )}
      {data.supplementInquiryStatusId === TSupplementResponseStatus.NeedsInfo && (
        <DeleteIcon
          className="medication-response-card__delete_icon pointer"
          color="error"
          onClick={handleRemove}
        />
      )}
    </div>
  );
};

export default MedicationResponseCard;
